export const INTRO_DATA = [
  {
    title: '개발자가 성장하면 \n온 세상이 성장한다',
    introduction:
      '개발자의 수많은 컨트리뷰션이 모여\n새로운 기술과 혁신을 만들고 있어요.',
    description:
      '이 사실을 널리 알리고\n모두가 개발자의 성장을 응원하도록\n항해99와 함께 세상의 성장에 기여해주세요.',
  },
];

export const DONATION_INFO_DATA = [
  {
    title: '잔디를 기부하면\n기부금이 쌓여요',
    introduction: '잔디 1개 = 100원으로 환산한 총 금액을 기부해요.',
    description:
      '저소득층 아동에게 코딩 교육을 지원하는\n단체에 기부되어, 아이들이 기회의 차등 없이\n개발자의 꿈을 키우도록 도와요.',
  },
];
